import { render, staticRenderFns } from "./SideMenuProjects.vue?vue&type=template&id=53764e88&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53764e88')) {
      api.createRecord('53764e88', component.options)
    } else {
      api.reload('53764e88', component.options)
    }
    module.hot.accept("./SideMenuProjects.vue?vue&type=template&id=53764e88&", function () {
      api.rerender('53764e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuProjects.vue"
export default component.exports